import RevenueBreakdownChart from './RevenueBreakdownChart';

export default RevenueBreakdownChart;
